module.exports = {"TXTWCL_Today":{"id":"TXTWCL_Today","defaultMessage":"Aujourd''hui"},"TXTWCL_Tomorrow":{"id":"TXTWCL_Tomorrow","defaultMessage":"Demain"}}